import React, { Component } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  forgotPasswordUserRequest,
  changePasswordUserRequest
} from '@redux/actions/AuthActions';
import { parseJwt } from '@utils/helpers';

import { withStyles } from '@material-ui/core/styles';
import Logo from '@assets/images/logo.png';
import { Button, TextField, Link, Typography } from '@material-ui/core';

import { styles } from './styles';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  }
};

class PasswordResetComponent extends Component {
  state = {
    token: null,
    value: '',
    formState: {
      isValid: false,
      values: {},
      touched: {},
      errors: {}
    }
  };

  componentDidMount() {
    const { formState } = this.state;
    const { id } = this.props.match.params;

    if (id) {
      const { email } = parseJwt(id);

      this.setState({
        token: this.props.match.params.id,
        formState: { ...formState, values: { email } }
      });
    }
  }

  handleChange = event => {
    const { formState } = this.state;

    const errors = validate(formState.values, schema);

    event.persist();

    this.setState({
      formState: {
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]: event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        },
        isValid: errors ? false : true,
        errors: errors || {}
      }
    });
  };

  handleForgetPwd = event => {
    const { email } = this.state.formState.values;
    event.preventDefault();

    this.props.setUserForgotPassword(email);
  };

  handleChangePassword = event => {
    const { values } = this.state.formState;
    event.preventDefault();

    const payload = {
      ...values,
      token: this.state.token
    };

    this.props.setUserChangePassword(payload);
  };

  hasError = field => {
    const { formState } = this.state;
    return formState.touched[field] && formState.errors[field] ? true : false;
  };

  render() {
    const { formState, token } = this.state;
    const { classes } = this.props;

    return (
      <div className={classes.content}>
        <img alt="Praexo" className={classes.logo} src={Logo} />

        <div className={classes.contentBody}>
          {token ? (
            <form className={classes.form} onSubmit={this.handleChangePassword}>
              <TextField
                className={classes.textField}
                error={this.hasError('email')}
                fullWidth
                helperText={
                  this.hasError('email') ? formState.errors.email[0] : null
                }
                label="Email address"
                name="email"
                onChangeText={this.handleChange}
                type="text"
                value={formState.values.email || ''}
                variant="outlined"
              />

              <TextField
                className={classes.textField}
                error={this.hasError('password')}
                fullWidth
                helperText={
                  this.hasError('password')
                    ? formState.errors.password[0]
                    : null
                }
                label="New Password"
                name="password"
                onChange={this.handleChange}
                type="password"
                value={formState.values.password || ''}
                variant="outlined"
              />
              <TextField
                className={classes.textField}
                error={this.hasError('password2')}
                fullWidth
                helperText={
                  this.hasError('password2')
                    ? formState.errors.password2[0]
                    : null
                }
                label="Confirm Password"
                name="password2"
                onChange={this.handleChange}
                type="password"
                value={formState.values.password2 || ''}
                variant="outlined"
              />

              <Button
                className={classes.signInButton}
                color="primary"
                disabled={!formState.isValid}
                size="large"
                type="submit"
                variant="contained">
                Reset Password
              </Button>
              <Typography color="textPrimary" variant="body1">
                Back to{' '}
                <Link component={RouterLink} to="/" variant="h6">
                  Login
                </Link>
              </Typography>
            </form>
          ) : (
            <form className={classes.form} onSubmit={this.handleForgetPwd}>
              <TextField
                className={classes.textField}
                error={this.hasError('email')}
                fullWidth
                helperText={
                  this.hasError('email') ? formState.errors.email[0] : null
                }
                label="Email address"
                name="email"
                onChange={this.handleChange}
                type="text"
                value={formState.values.email || ''}
                variant="outlined"
              />

              <Button
                className={classes.signInButton}
                color="primary"
                disabled={!formState.isValid}
                size="large"
                type="submit"
                variant="contained">
                Reset Password
              </Button>
              <Typography color="textPrimary" variant="body1">
                Back to{' '}
                <Link component={RouterLink} to="/" variant="h6">
                  Login
                </Link>
              </Typography>
            </form>
          )}
        </div>
      </div>
    );
  }
}

PasswordResetComponent.propTypes = {
  classes: PropTypes.any,
  history: PropTypes.object
};

export const mapStateToProps = state => ({ auth: state.auth });

export const mapDispatchToProps = dispatch => {
  return {
    setUserForgotPassword: email => dispatch(forgotPasswordUserRequest(email)),
    setUserChangePassword: payload =>
      dispatch(changePasswordUserRequest(payload))
  };
};

export const PasswordReset = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(withRouter(PasswordResetComponent));

export default PasswordReset;
